// The reader's blunders and misses over the whole game, by the review's own
// judgements (`GameScan.kind`).
import type { FactExtractor, ScannedGame } from '../extractor.ts';
import { type GameFacts } from '@chess/api-model';

export const judgements: FactExtractor = {
  id: 'judgements',
  extract(game: ScannedGame, facts: GameFacts): void {
    let blunders = 0;
    let misses = 0;
    game.moves.forEach((move, i) => {
      const ply = i + 1;
      if (!game.isReaders(ply)) return;
      const kind = game.judge.kind(ply, move, game.reader);
      if (kind === 'blunder') blunders += 1;
      else if (kind === 'miss') misses += 1;
    });
    facts.blunders = blunders;
    facts.misses = misses;
  },
};
